export var title = "Lyse Gatelys";
export var Config = {
    ext: {},
    MELDINGSTYPE: 'MELDINGSTYPE'
}